import http from './http';

export const login = async (username, password) => {
  const response = await http.post('/login_check', {
    username: btoa(username),
    password: btoa(password),
  }, {
    notify: false,
  });

  return response.data;
};
